import { createSlice } from '@reduxjs/toolkit';
import { IMaterial } from '../../../models/materials';

interface IMaterialState {
    materials: IMaterial[],
    isLoading: boolean,
};

const initialState: IMaterialState = {
    materials: [],
    isLoading: false,
};

export const materialsSlice = createSlice({
    name: 'materials',
    initialState,
    reducers: {
        startLoadingMaterials: (state) => {
            state.isLoading = true;
        },
        setMaterials: (state, action) => {
            state.isLoading = false;
            state.materials = action.payload.materials;
        }
    }
});

// Action creators are generated for each case reducer function
export const { startLoadingMaterials, setMaterials } = materialsSlice.actions;